/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * Authentication state of the user
 */
export enum AutociteAuthStateEnum {
  HARD_LOGGED_IN = 'HARD_LOGGED_IN',
  LOGGED_OUT = 'LOGGED_OUT',
  SOFT_LOGGED_IN = 'SOFT_LOGGED_IN',
}

/**
 * Constants to identify type of the paper check
 */
export enum CheckTypeInput {
  CLARITY_REASON = 'CLARITY_REASON',
  FULL = 'FULL',
  GRAMMAR = 'GRAMMAR',
  PARAPHRASE = 'PARAPHRASE',
  PARAPHRASE_SELECTION = 'PARAPHRASE_SELECTION',
  PARAPHRASE_SELECTION_EXPAND = 'PARAPHRASE_SELECTION_EXPAND',
  PARAPHRASE_SELECTION_SHORTEN = 'PARAPHRASE_SELECTION_SHORTEN',
  SYNONYM_SELECTION = 'SYNONYM_SELECTION',
}

/**
 * Enum for citation created at order
 */
export enum CitationsSortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

/**
 * Category of the Feedback
 */
export enum FeedbackType {
  GRAMMAR = 'GRAMMAR',
  PARAPHRASE = 'PARAPHRASE',
  SYNONYM = 'SYNONYM',
}

/**
 * Change type representing how sentence is changed
 */
export enum PaperSentenceChangeType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
  REPLACE = 'REPLACE',
}

/**
 * Constants to define status of a paper
 */
export enum PaperStatus {
  ALL_SET = 'ALL_SET',
  DRAFT = 'DRAFT',
  IN_REVIEW = 'IN_REVIEW',
}

/**
 * Author of the website we recieved in autocite service response
 */
export interface AutociteAuthorNameInput {
  authorGivenName?: string | null
  authorLastName?: string | null
}

/**
 * Client common fields input to send in Rio event
 */
export interface AutociteClientCommonFieldInput {
  adobeMcid?: string | null
  authState?: AutociteAuthStateEnum | null
  cheggSessionId?: number | null
  cheggVisitorId?: string | null
  referralUrl?: string | null
  userUuid?: any | null
}

/**
 * Input for query autociteCslData
 */
export interface AutociteCslDataInput {
  clientCommonField?: AutociteClientCommonFieldInput | null
  trackingId?: any | null
  url: string
}

/**
 * Editor of the website we recieved in autocite service response
 */
export interface AutociteEditorNameInput {
  editorGivenName?: string | null
  editorLastName?: string | null
}

/**
 * Input for mutation submitAutociteResponse
 */
export interface AutociteInput {
  autociteResponse: AutociteMetadataInput
  clientCommonField: AutociteClientCommonFieldInput
  numFieldsAutocite: number
  trackingId: any
}

/**
 * Autocite service response for any cited url
 */
export interface AutociteMetadataInput {
  accessedPublicationDay?: number | null
  accessedPublicationMonth?: string | null
  accessedPublicationYear?: number | null
  authors: AutociteAuthorNameInput[]
  containerTitle?: string | null
  contentSource?: string | null
  contentTitle?: string | null
  editors: AutociteEditorNameInput[]
  issuedPublicationDay?: number | null
  issuedPublicationMonth?: string | null
  issuedPublicationYear?: number | null
  metricsRule?: string | null
  metricsRuleVersion?: string | null
  publisherName?: string | null
  translators: AutociteTranslatorNameInput[]
  url?: string | null
}

/**
 * Translator of the website we recieved in autocite service response
 */
export interface AutociteTranslatorNameInput {
  translatorGivenName?: string | null
  translatorLastName?: string | null
}

/**
 * Input type for the Create Paper mutation
 */
export interface CreateProofReaderPaperInput {
  requiresReCheck: boolean
  status?: PaperStatus | null
  title: string
  paperContent: any
  paperId: any
  feedbackState: FeedbackStateInput
  createdAt?: any | null
}

/**
 * Input type for the feedback
 */
export interface FeedbackInput {
  id: any
  sentenceId: any
  feedbackType: FeedbackType
  reason?: string | null
  changeType?: PaperSentenceChangeType | null
  position?: TextPositionInput | null
  suggestedText: string
}

/**
 * Input type for the feedback reason query
 */
export interface FeedbackReasonInput {
  checkType?: CheckTypeInput | null
  correctedSentence: string
  initiatedAt: any
  originalSentence: Sentence
  paperId: any
  traceId: any
}

/**
 * Input type for the feedback stats of paper
 */
export interface FeedbackStateInput {
  sentences: PaperSentenceInput[]
  feedbackList: FeedbackInput[]
  initialFeedbackCount?: number | null
}

/**
 * Input type for the paper check mutation
 */
export interface PaperCheckInput {
  initiatedAt: any
  paperContent?: any | null
  paperId?: any | null
  paperText: string
  title?: string | null
  traceId: any
}

/**
 * Input type representing single sentence from a paper
 */
export interface PaperSentenceInput {
  id: any
  position: TextPositionInput
}

/**
 * Input type for the Sentence
 */
export interface Sentence {
  originalText: string
  id: any
}

/**
 * Input type for the Sentence Check mutation
 */
export interface SentenceCheckInput {
  sentences: Sentence[]
  paperId: any
  traceId: any
  initiatedAt: any
  checkType: CheckTypeInput
  synonymPosition?: TextPositionInput | null
}

/**
 * Input type to represent position of a text
 */
export interface TextPositionInput {
  length: number
  offset: number
}

/**
 * Input type for the Update Paper mutation
 */
export interface UpdateProofReaderPaperInput {
  feedbackState?: FeedbackStateInput | null
  requiresReCheck?: boolean | null
  status?: PaperStatus | null
  title?: string | null
  paperContent?: any | null
  paperId: any
}

//==============================================================
// END Enums and Input Objects
//==============================================================
